<capra-button *ngIf="datasetsReportType; else infoText"
  class="dependency-copy"
  text="View usage: {{ totalCount }}"
  variant="secondary"
  [color]="theme === 'light' ? 'neutral' : 'neutral-light'"
  size="small"
  (clicked)="openDatasetUsageModal()"
></capra-button>

<ng-template #infoText>
  <span class="dependency-copy"
    capraTooltip
    [tooltipContent]="tooltipCopy"
    tooltipPlacement="bottom"
    [tooltipInteractive]="false"
  >
    {{ dependencyCopy }}
    <capra-icon class="tooltip-icon" icon="icon-info-outline"></capra-icon>
  </span>
</ng-template>
